import React from 'react';
import { useLocation } from 'react-router-dom';
import angular from 'angular';
import { react2angular } from 'react2angular';
import AiInsightsContextProvider from './context/AiInsightsContext';
import AiInsightListContainer from './List/AiInsightsListContainer';
import { I18nextProvider } from 'react-i18next';
import newInstanceI18next from '../../../Util/traductionUtils';

export default function AiInsightsContainer(props) {

	const location = useLocation(); 

	if (location.pathname !== '/Insight/AiInsights') {
		return <></>;
	}

	return (
		<I18nextProvider i18n={newInstanceI18next}>
			<AiInsightsContextProvider {...props}>
				<AiInsightListContainer />
			</AiInsightsContextProvider>
		</I18nextProvider>
	);
}

angular
	.module('beyableSaasApp.AiInsights', [])
	.component(
		'aiInsightsContainer',
		react2angular(AiInsightsContainer, [], ['$rootScope', '$http', '$routeParams', '$timeout', '$location', 'AuthServices'])
	);
